import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createFaq } = EventsApiService();

export const useCreateFaq = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return createFaq(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (variables: any) => {
                if (variables.id) {
                    message.success("Faq's has been updated successfully!!");
                } else {
                    message.success("Faq's has been created successfully!!");
                }
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
            },
        },
    );
};
